import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueRouter from 'vue-router'
import MainPage from './components/MainPage'
import ContactForm from './components/ContactForm'


Vue.config.productionTip = false

Vue.use(VueRouter)

const routes=[
     {path: '/contactform', component: ContactForm },
     {path: '/mainpage', component: MainPage , alias:'/' },
   ]

const router = new VueRouter({
  routes
})

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
